module.exports = __webpack_public_path__ + "static/media/slogan.7d29a8e0.png";